<template>
  <div class="flex flex-1 touch-pan-y flex-col overflow-y-auto overscroll-contain bg-light-bg-disabled px-4 py-6">
    <div class="flex flex-col gap-6">
      <section class="flex flex-col gap-3">
        <h3 class="text-center text-lg font-bold text-light-fg-emphasis">Before You Begin</h3>
        <div class="flex flex-col gap-4 text-base leading-relaxed text-light-fg-muted">
          <div>
            <p class="font-bold text-light-fg-default">About this service</p>
            <p>This service uses generative AI, and responses may occasionally be incomplete or inaccurate.</p>
            <p>Wabunka AI Chat can answer questions about the experiences, but cannot make bookings, submit inquiries, or contact Wabunka staff or hosts on your behalf.</p>
            <p>
              Please use the booking page to make a booking or the
              <NuxtLink class="font-medium text-light-fg-accent underline underline-offset-2" rel="noopener noreferrer" target="_blank" :to="`/contact/?experience=${slug}`">contact form</NuxtLink>
              to reach our team.
            </p>
          </div>
          <div>
            <p class="font-bold text-light-fg-default">Your privacy</p>
            <p>Please do not enter personal or confidential information.</p>
          </div>
          <div>
            <p class="font-bold text-light-fg-default">Data handling</p>
            <p>Your input is processed by J-CAT, Inc. and selected service providers, within and outside Japan, solely to provide this service. Your data is not used to train AI models.</p>
          </div>
          <div>
            <p class="font-bold text-light-fg-default">Under 18</p>
            <p>If you are under 18, please confirm you have parental or guardian consent.</p>
          </div>
        </div>
      </section>
    </div>

    <div class="mt-6">
      <PrimaryButton :on-click="() => $emit('agree')">Agree and continue</PrimaryButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PrimaryButton } from '@/wabunka-src/common/components';

defineProps<{
  slug: string;
}>();

defineEmits<{
  agree: [];
}>();
</script>
